<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Edit Company</span>
      </section>
    </article>
    <h4>Edit Company</h4>
    <article class="row">
      <section class="input-field col s2">
        <input type="number"
               placeholder="123456"
               class="validate"
               v-model="company.id"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">
          Company ID
        </label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="12345"
               class="validate"
               v-model="company.capiq_identifier"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">
          CapIQ
        </label>
      </section>
      <section class="input-field col s5">
        <input type="text"
               placeholder="Facebook"
               class="validate"
               v-model="payload.name"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          Company Name
        </label>
      </section>
      <section class="input-field col s3">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="payload.usm_temp_import"
                   :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
            >
            <span>USM Temp Import</span>
          </label>
        </p>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.country_id"
                v-if="countries.length"
                :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
          <option v-for="country of countries"
                  :key="country.id"
                  :value="country.id"
          >
            {{ country.code }} {{ country.name }}
          </option>
        </select>
        <label class="active">Country</label>
      </section>
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.sector_id"
                v-if="sectors.length"
                :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
          <option v-for="sector of sectors"
                  :key="sector.id"
                  :value="sector.id"
          >
            {{ sector.name }}
          </option>
        </select>
        <label class="active">
          Sector
        </label>
      </section>
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.industry_id"
                v-if="industries.length"
                :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
          <option v-for="industry of industries"
                  :key="industry.id"
                  :value="industry.id"
          >
            {{ industry.name }}
          </option>
        </select>
        <label class="active">
          Industry
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s6">
        <input id="ticker-admin-edit-company-inactive-date"
               type="text"
               class="datepicker"
               v-model="company.inactive_date"
               @change="payload.inactive_date = $event.target.value"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          Inactive Date
        </label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveCompany"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

const defaultPayload = {
  analyst_id: 0,
  company_id: 0,
  name: '',
  country_id: 0,
  active: false,
  inactive_date: null,
  sector_id: 0,
  industry_id: 0,
  usm_temp_import: false,
};

export default {
  name: 'TickerAdminEditCompany',
  components: {},
  props: {},
  data() {
    return {
      sectors: [],
      industries: [],
      countries: [],
      company: {},
      payload: { ...defaultPayload },
    };
  },
  computed: {
    capiq_identifier() {
      return this.$route.query.capiq_identifier || 0;
    },
    companyId() {
      return this.$route.query.company_id || 0;
    },
    body() {
      const body = {
        company_id: this.company.id,
        analyst_id: this.$auth.user.pk,
        capiq_identifier: this.company.capiq_identifier,
      };
      if (this.payload.name !== this.company.name) { body.name = this.payload.name.trim(); }
      if (this.payload.country_id !== this.company.country.id) { body.country_id = this.payload.country_id; }
      if (this.payload.sector_id !== this.company.sector.id) { body.sector_id = this.payload.sector_id; }
      if (this.payload.industry_id !== this.company.industry.id) { body.industry_id = this.payload.industry_id; }
      if (this.payload.inactive_date !== this.company.inactive_date) {
        body.inactive_date = this.payload.inactive_date || null;
        body.active = !body.inactive_date;
      }
      if (this.payload.usm_temp_import !== this.company.usm_temp_import) { body.usm_temp_import = this.payload.usm_temp_import; }
      return body;
    },
  },
  watch: {},
  methods: {
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/sectors/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/countries/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/industries/`),
      ];
      const [sectorsResp, countriesResp, industriesResp] = await Promise.all(promises);
      [this.sectors, this.countries, this.industries] = [sectorsResp.data, countriesResp.data, industriesResp.data];
    },
    async fetchCompany() {
      let urlParam;
      if (this.capiq_identifier) {
        urlParam = `?capiq_identifier=${this.capiq_identifier}`;
      } else if (this.companyId) {
        urlParam = `?company_id=${this.companyId}`;
      }
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/company/${urlParam}`);
      this.company = data;
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.company_id = this.company.id;
      this.payload.name = this.company.name;
      this.payload.country_id = this.company.country.id;
      this.payload.sector_id = this.company.sector.id;
      this.payload.industry_id = this.company.industry.id;
      this.payload.active = !this.company.inactive_date;
      this.payload.inactive_date = this.company.inactive_date;
      this.payload.usm_temp_import = this.company.usm_temp_import;
    },
    async saveCompany() {
      if (![
        this.body.analyst_id,
        this.body.company_id,
        this.body.capiq_identifier,
      ].every(arg => Boolean(arg))) {
        return this.toast('Please populate all required fields', 'pink');
      }
      if (!new RegExp(/^[0-9]+$/g).test(this.body.capiq_identifier)) {
        return this.toast('CapIQ identifier  value must be in the format "[0-9]"', 'pink');
      }
      if (String(Object.keys(this.body)) === String(['company_id', 'analyst_id', 'capiq_identifier'])) {
        return this.toast('Please modify at least one field', 'pink');
      }
      const { data } = await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/company/`, this.body);
      this.toast('Companed saved!', 'green');
      this.payload = { ...defaultPayload };
      document.getElementById('ticker-admin-edit-company-inactive-date').value = '';
      this.fetchCompany();
    },
  },
  mounted() {
    this.fetchMetadata();
    this.fetchCompany();
    this.initDatepicker();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';


</style>
